import FILTER_KEYS from "./constants";

const generateRuleAttributes = (
    ruleType = null,
    temporalRuleType = null,
    valueAttribute = null,
    ruleTitle = "Filtro Base",
    temporalRulesTitle = "Filtri Temporali",
    temporalRulesSubtitle = "Non inviarmi richieste nei seguenti periodi:",
    valueLabel = "Value Label",
    defaultValue = null,
    hasBooleanValue = false,
    defaultPeriod = [null, null]) => {

    return {
        ruleType,
        temporalRuleType,
        valueAttribute,
        ruleTitle,
        temporalRulesTitle,
        temporalRulesSubtitle,
        valueLabel,
        defaultValue,
        hasBooleanValue,
        defaultPeriod
    }
};

const periodAttributes = generateRuleAttributes(
    null,
    1,
    null,
    null,
    "Periodi non disponibili",
    "Non inviarmi richieste nei seguenti periodi:",
    null,
    null,
    false,
    [null, null],
);

const minNightsAttributes = generateRuleAttributes(
    2,
    52,
    FILTER_KEYS.minNightsLimit,
    "Filtro Base",
    "Filtri Temporali",
    "Non inviarmi richieste se vale una delle seguenti condizioni:",
    "Minimo notti",
    3,
    false,
    [null, null]
);

const minPeopleAttributes = generateRuleAttributes(
    3,
    53,
    FILTER_KEYS.minPeopleLimit,
    "Filtro Base",
    "Filtri Temporali",
    "Non inviarmi richieste se vale una delle seguenti condizioni:",
    "Minimo numero di persone",
    4,
    false,
    [null, null]
);

const maxPeopleAttributes = generateRuleAttributes(
    4,
    54,
    FILTER_KEYS.maxPeopleLimit,
    "Filtro Base",
    "Filtri Temporali",
    "Non inviarmi richieste se vale una delle seguenti condizioni:",
    "Massimo numero di persone",
    8,
    false,
    [null, null]
);

const maxPetsAttributes = generateRuleAttributes(
    5,
    55,
    FILTER_KEYS.maxPetsLimit,
    "Filtro Base",
    "Filtri Temporali",
    "Non inviarmi richieste se vale una delle seguenti condizioni:",
    "Massimo numero di animali ammessi",
    0,
    false,
    [null, null]
);

const bookingAttributes = generateRuleAttributes(
    10,
    null,
    null,
    "Descrizione filtro",
    null,
    null,
    null,
    true,
    true,
    null
);

export {periodAttributes, minNightsAttributes, minPeopleAttributes, maxPeopleAttributes, maxPetsAttributes, bookingAttributes}